import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { BaseUrl } from '../../helper/BaseUrl';
import { useModal } from '../../contexts/ModalContext';
import { getMediaUrl } from '../../helper/mediaUrl';

export default function OfferDetail({ initialData }) {
    const { offer_slug } = useParams();
    const [data, setdata] = useState(initialData || {});
    const navigate = useNavigate();

    const { openQueryModal } = useModal();

    useEffect(() => {
        const aifetcher = async () => {
            try {
                const response = await fetch(`${BaseUrl}/api/offer/view/${offer_slug}`, {
                    method: 'GET',
                });
                const result = await response.json();
                if (!result.offer) {
                    navigate("/404", { replace: true });
                    return;
                }
                setdata(result.offer);
            } catch (error) {
                console.error('Fetch error:', error.message);
            }
        };
        aifetcher();
    }, [offer_slug, navigate]);


    return (
        <>
            <section className="image-subhead offerdetail-banner">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6">
                            <ul>
                                <li><Link to={"/"}>Home</Link></li>
                                <li><Link to={"/offer-listing"}>Offer Listing</Link></li>
                                <li> {data?.title}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <img src={getMediaUrl(data?.banner_image)} className="img-responsive" alt={data?.banner_image_alt} loading="lazy" />
            </section>


            <section className="offerdetail-content">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-8">
                            <div className="offerdetail-detail">
                                <h1 className='offerdetail-head'>{data?.title}</h1>
                                <span><img src="/image/star-icon.webp" alt="star" loading="lazy" /> Minimum Stay: {data?.minimum_stay}</span>
                                <p dangerouslySetInnerHTML={{ __html: data?.description }} />
                            </div>

                            <div className="offerdetail-time">
                                <h2 className='offerdetail-head'>Date & Time</h2>
                                <div dangerouslySetInnerHTML={{ __html: data?.date_time }} />
                            </div>

                            <div className="offerdetail-include">
                                <h3 className='offerdetail-head'>Included Services</h3>
                                <div dangerouslySetInnerHTML={{ __html: data?.include_service }} />
                            </div>

                            <div className="offerdetail-include">
                                <h4 className='offerdetail-head'>Additional Information</h4>
                                <div dangerouslySetInnerHTML={{ __html: data?.additional_information }} />
                            </div>
                        </div>


                        <div className="col-lg-4 col-md-4">
                            <div className="offer-enquirybox">
                                <p>Your wilderness escape is just a click away. Select how you'd like to plan your stay.</p>

                                <small><img src="/image/edit-icon.webp" alt="edit" loading="lazy" /> Have a special request or need help planning? Let us know - we'll craft the perfect wilderness experience just for you.</small>

                                <div className='text-center'>
                                    <Link onClick={openQueryModal} className="default-btn color-btn">Enquire Now</Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}
